import React, { useCallback, useEffect } from "react";
import {
  Navigate,
  useLocation,
  matchRoutes,
  useNavigate,
} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { isExpired } from "react-jwt";


import Storage from "../utils/storage";
import toast from "../utils/toastsMessage";
import { ROLES } from "../constant/commonConstants";
import ROUTES, {
  ADMIN_ROUTES,
  ARTIST_ROUTES,
  COMMON_ROUTES,
  USER_ROUTES,
} from "../constant/routes";
import { getUserStatus } from "../services/user";
import { authIntialState, authStore } from "../store/authStore";

interface Props {
  component: React.ComponentType;
}

const ProtectedRoutes: React.FC<Props> = ({ component: RouteComponent }) => {
  const { t: translation } = useTranslation();
  const {state:authUser,update} = authStore((state) => state);
  
  const { pathname } = useLocation();
  const location = useLocation();
  const route = location?.pathname;
  const navigate = useNavigate();

  const userRoute = matchRoutes(USER_ROUTES, pathname);
  const adminRoute = matchRoutes(ADMIN_ROUTES, pathname);
  const artistRoute = matchRoutes(ARTIST_ROUTES, pathname);
  const commonRoute = matchRoutes(COMMON_ROUTES, pathname);

  const tokenData = Storage.get("__RTA__");

  useEffect(() => {
    sessionExpire();
  }, []);

  const sessionExpire = () => {
    const isMyTokenExpired = isExpired(tokenData);

    if (isMyTokenExpired) {
      localStorage.clear();
      toast.error(translation("token-expired"));
      window.location.reload();
    }
  };

  useEffect(() => {
    if (authUser?.isLoggedIn) {
      (async () => {
        await checkUserStatus();
      })();
    }
  }, [route]);

  const checkUserStatus = useCallback(async () => {
    if(!authUser?.email)return;
    
    const {data} = await getUserStatus({
      email: authUser?.email,
    });

    if (!data?.success || data?.data[0]?.is_active===0) {
      localStorage.clear();
      // dispatch({
      //   type: ActionType.LOGOUT,
      // });
      update(authIntialState)
      toast.error(translation(`${data?.message}`));
      navigate(ROUTES.HOME);
      window.location.reload();
    }
  }, []);

  if (tokenData && authUser.isLoggedIn) {
    if (authUser?.account_type === ROLES.USER) {
      if (userRoute?.length || commonRoute?.length) {
        return <RouteComponent />;
      }
      return (
        <h1 className="text-center">{translation("unauthorized_user")}</h1>
      );
    }
    if (authUser?.account_type === ROLES.ARTIST) {
      if (artistRoute?.length) {
        return <RouteComponent />;
      }
      return (
        <h1 className="text-center">{translation("unauthorized_user")}</h1>
      );
    }
    if (authUser?.account_type === ROLES.ADMIN) {
      if (adminRoute?.length) {
        return <RouteComponent />;
      }
      return (
        <h1 className="text-center">{translation("unauthorized_user")}</h1>
      );
    }
  }
  return (
    <Navigate
      to={authUser?.account_type === ROLES.USER ? "/" : ROUTES.LOGIN}
    />
  );
};
export default ProtectedRoutes;
